import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import axios from 'axios';

export default function Contact() {
    const form = useRef();
    const [loading, setLoading] = useState(false);

    // Function to load the reCAPTCHA script
    const loadRecaptchaScript = () => {
        if (typeof window.grecaptcha === 'undefined') {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=6LcavoEqAAAAAEKdcDo89E07x54jlzK5Aa7PSvd5`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            // Ensure the reCAPTCHA script is loaded
            loadRecaptchaScript();


            // Generate the token and send it to your server for verification
            window.grecaptcha.enterprise.execute('6LcavoEqAAAAAEKdcDo89E07x54jlzK5Aa7PSvd5', { action: 'SUBMIT' })
            .then((token) => {
                console.log('Generated token:', token);

                const requestBody = {
                    event: {
                        token: token,
                        expectedAction: 'SUBMIT',
                        siteKey: '6LcavoEqAAAAAEKdcDo89E07x54jlzK5Aa7PSvd5',
                    },
                };

                const API_KEY = process.env.REACT_APP_API_KEY;
                
                axios.post(
                    `https://recaptchaenterprise.googleapis.com/v1/projects/veronikas-websit-1731849948926/assessments?key=${API_KEY}`,
                    requestBody,
                    { headers: { 'Content-Type': 'application/json' } }
                )
                .then((response) => {
                    console.log('reCAPTCHA verification response:', response.data);
                    // If reCAPTCHA verification is successful, proceed with form submission
                    if (response.data.tokenProperties.valid) {
                        // Send email via EmailJS
                        emailjs.sendForm('service_qymi1np', 'template_qxj0c7q', form.current, {
                            publicKey: 'mh-aIPB7JzEAHcdmH',
                        }).then(
                            () => {
                                form.current.reset();
                                Swal.fire({
                                    title: 'Email sent',
                                    text: 'I will get back to you as soon as I can!',
                                    icon: 'success',
                                    toast: true,
                                    position: 'top-end',
                                    timer: 5000,
                                    timerProgressBar: true,
                                    showConfirmButton: false,
                                });
                            },
                            (error) => {
                                Swal.fire({
                                    title: 'Email not sent',
                                    text: 'Something went wrong with the online form. Please send me a mail manually!',
                                    icon: 'error',
                                    toast: true,
                                    position: 'top-end',
                                    timer: 10000,
                                    timerProgressBar: true,
                                    showConfirmButton: false,
                                });
                                console.error('FAILED...', error.text);
                            }
                        );
                    }
                })
                .catch((error) => {
                    console.error('reCAPTCHA verification error:', error);
                });
            })
            .catch((error) => {
                console.error('Error generating reCAPTCHA token:', error);
            });


            
        } catch (error) {
            Swal.fire({
                title: 'Please verify you are a human!',
                text: error.message || 'An unexpected error occurred.',
                icon: 'error',
                toast: true,
                position: 'bottom-start',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: false,
            });
        } 
            setLoading(false);
        
    };

    return (
        <section data-scroll-data="7" id="contact" className="section contact-section bg-slate-900" style={{ "backgroundImage": "url(img/effect/bg-effect-3.png)", "backgroundRepeat": "no-repeat", "backgroundSize": "cover", "backgroundPosition": "center"}}>
            <div className="container">
                <div className="grid grid-cols-12">
                    <div className="col-span-12 lg:col-span-6 ">
                        <div className="p-[25px] md:p-[35px] bg-white">
                            <h6 className="text-[32px] font-[600] text-black mb-[5px]">Get in touch</h6>
                            <form onSubmit={handleSubmit} ref={form}>
                                <input name="bot" id="bot" type="hidden" value="" className="hidden invisible"/>
                                <div className="grid grid-cols-12 gap-3">
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="form-group">
                                            <label className="form-label">First name</label>
                                            <input name="from_name" id="name" placeholder="Name *" className="form-control" type="text" required/>
                                        </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-6">
                                        <div className="form-group">
                                            <label className="form-label">Your Email</label>
                                            <input name="from_email" id="email" placeholder="Email *" className="form-control" type="email" required/>
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="form-group">
                                            <label className="form-label">Subject</label>
                                            <input name="subject" id="subject" placeholder="Subject *" className="form-control" type="text" required/>
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="form-group">
                                            <label className="form-label">Your message</label>
                                            <textarea name="message" id="message" placeholder="Your message *" rows="4" className="form-control" required></textarea>
                                        </div>
                                    </div>
                                    <div className="col-span-12">
                                        <div className="send">
                                            <button className="px-btn px-btn-theme2 sm:w-auto w-full" type="submit" disabled={loading}>
                                                {loading ? 'Sending...' : 'Send Message 💌'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-6 flex">
                        <div className="lg:max-w-[410px] w-full lg:ml-auto py-[50px] lg:pt-0">
                            <div className="pb-10">
                                <img className="w-full" src="img/contact-blazer.png" title="" alt="" />
                            </div>
                            <ul className="contact-infos">
                                <li>
                                    <div className="icon bg-1">
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    <div className="col">
                                        <h5>Phone</h5>
                                        <p>+359 877610337</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon bg-2">
                                        <i className="fas fa-phone-alt"></i>
                                    </div>
                                    <div className="col">
                                        <h5>Mail</h5>
                                        <p>veronika.licheva23@gmail.com</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon bg-3">
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="col">
                                        <h5>Base of operations</h5>
                                        <p>Bulgaria</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
